
import React, { useEffect, useState } from 'react';

const ForumCollaboratif = ({ journeyId, userId }) => {
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState('');

  useEffect(() => {
    fetch(`/api/collab/discussion/${journeyId}`)
      .then(res => res.json())
      .then(setMessages);
  }, [journeyId]);

  const handleSend = async () => {
    if (!newMsg.trim()) return;
    await fetch('/api/collab/discussion', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ journeyId, userId, message: newMsg })
    });
    setNewMsg('');
    const res = await fetch(`/api/collab/discussion/${journeyId}`);
    setMessages(await res.json());
  };

  return (
    <div className="p-4 bg-white rounded shadow mt-6">
      <h3 className="text-lg font-semibold mb-2">Discussion collaborative</h3>
      <div className="h-48 overflow-y-auto border p-2 rounded bg-gray-50">
        {messages.map((msg, idx) => (
          <div key={idx} className="mb-2">
            <span className="text-sm text-gray-600">{msg.userId}</span>
            <p className="text-gray-800">{msg.message}</p>
          </div>
        ))}
      </div>
      <div className="mt-2 flex">
        <input
          className="flex-1 border px-2 py-1 rounded-l"
          value={newMsg}
          onChange={e => setNewMsg(e.target.value)}
          placeholder="Votre message..."
        />
        <button className="bg-blue-600 text-white px-4 rounded-r" onClick={handleSend}>Envoyer</button>
      </div>
    </div>
  );
};

export default ForumCollaboratif;
